import { render, staticRenderFns } from "./Consumption.vue?vue&type=template&id=ec357e6c&"
import script from "./Consumption.vue?vue&type=script&lang=ts&"
export * from "./Consumption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports